import React from "react";
import "./cookiesPolicy.css";

import Meta from "utils/meta";

const CookiePolicy = () => {
  return (
    <div>
      <Meta title="Cookie Policy | The Realtor Desk" description="" />
      <div className="cookiePolicy-container">
        <div className="cookiePolicy-heading">
          <h1>The Realtor Desk Cookies Policy </h1>
        </div>
        <div className="cookiePolicy-description-head">
          <p>
            Please read this cookie policy carefully as it contains important
            information on who we are and how we use cookies on our website.
            This policy should be read together with our privacy policy which
            sets out how and why we collect, store, use and share personal
            information generally, as well as your rights in relation to your
            personal information and details of how to contact us and
            supervisory authorities if you have a complaint.
          </p>
        </div>
        <div className="cookiePolicy-description">
          <div className="cookiePolicy-who-we-are">
            <h1>Who we are? </h1>
            <p>
              This website is operated by the The Realtor Desk Network. The
              Realtor Desk is a set of related Internet sites and other
              applications for real estate.
            </p>
          </div>
          <div className="cookiePolicy-our-website">
            <h1>Our website </h1>
            <p>
              This cookie policy only relates to your use of our websites, apps
              and services listed below:
            </p>
            <p>therealtordesk.wep.com</p>
            <p>
              Throughout our websites we may link to other websites owned and
              operated by certain trusted third parties to service
              advertisements or provide analytical services. These other third
              party websites may also use cookies or similar technologies in
              accordance with their own separate policies. For privacy
              information relating to these other third party websites, please
              consult their policies as appropriate.
            </p>
          </div>
          <div className="cookiePolicy-cookies">
            <h1>Cookies</h1>
            <p>
              A cookie is a small text file that our sites store on your
              computer or mobile device when you visit our websites. Our
              websites, apps and other services (“Sites”), send this data to
              your browser when you first request a web page and then store the
              data on your computer or other device so the website or app can
              access, store or collect information from your device when you
              first request a web page. Browsers support cookies and similar
              technologies (such as local storage and pixels) so that our
              websites can remember information about your visit and can use the
              information to improve your experience and to create aggregated
              anonymized statistics about usage of the site. In this Policy, we
              use the term “cookie” to refer both to cookies and similar
              technologies.
            </p>
            <p>
              Cookies may be set by the site you are visiting (“first-party
              cookies”) or by a third party, such as those who provide analytics
              or advertising services or interactive content on the site
              (“third-party cookies”). In addition to using cookies on our
              sites, we may also serve our cookies (specifically, our
              advertising pixel) on third-party sites operated by our
              advertisers who use our advertising platform.
            </p>
            <p>
              If you use the The Realtor Desk Network, both The Realtor Desk and
              third parties will use cookies to track and monitor some of your
              activities on and off the The Realtor Desk Network, and store and
              access some data about you, your browsing history, and your usage
              of the The Realtor Desk Network.
            </p>
          </div>
          <div className="cookiePolicy-third-party">
            <h1>Third Party Cookies </h1>
            <p>
              Our third party partners and other organizations that sponsor
              pages on The Realtor Desk may use cookies or other technologies to
              learn more about your interest in their products and services and
              in some cases to tailor such products and services to you.
            </p>
            <p>
              Third-Party Cookies: Our services also include cookies from third
              parties that we partner with or which provide services us. These
              include third party companies that work with us or with
              advertisers who advertise on the Stack Exchange Network in order
              to help target ads or measure the results of an advertising
              campaign.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookiePolicy;
